import { FC } from "react";
import { AdequacyScore } from "./interfaces";

interface ScorecardProps {
  data: AdequacyScore;
  title: string;
}

export const Scorecard: FC<React.PropsWithChildren<ScorecardProps>> = (props: ScorecardProps) => {
  return (
    <div className="aga-scorecard">
      <h2 className="header-s aga-scorecard__title">{props.title}</h2>
      <div className="aga-scorecard__box">
        <div>
          {props.data.score}
          <div className="label-m fw-normal">Adequacy Score</div>
          {props.data.scoreChange !== undefined && props.data.scoreChange !== null && <div className="label-s">{props.data.scoreChange.toFixed(1)} change in score</div>}
        </div>
        <div>
          {props.data.gaps}
          <div className="label-m fw-normal">Gaps</div>
          {props.data.gapsChange !== undefined && props.data.gapsChange !== null && <div className="label-s">{props.data.gapsChange} change in gaps</div>}
        </div>
      </div>
      <p className="copy-text-default mt-2 mb-2">{props.data.accessOnlyMetCount ? props.data.accessOnlyMetCount : 0} gaps met access requirements only</p>
      <p className="copy-text-default mt-2 mb-2">{props.data.servicingOnlyMetCount ? props.data.servicingOnlyMetCount : 0} gaps met servicing providers requirements only</p>
      <p className="copy-text-default mt-2 mb-2">{props.data.noneMetCount ? props.data.noneMetCount : 0} gaps do not meet any adequacy requirements</p>
      {props.data.gapsChange !== undefined && props.data.gapsChange !== null && <p className="copy-text-default mt-2 mb-2 text-danger demibold">{props.data.gapsChange} projected gaps caused by invalid data within network</p>}
    </div>
  );
}
